import { LoaderFunctionArgs, RouteObject } from 'react-router';

import { Artists } from '@/ui/pages/external/venue/dates/artists/Artists';
import { ArtistsAccommodation } from '@/ui/pages/external/venue/dates/artists-accommodation/ArtistsAccommodation';
import { ArtistsCargo } from '@/ui/pages/external/venue/dates/artists-cargo/ArtistsCargo';
import { ArtistsCatering } from '@/ui/pages/external/venue/dates/artists-catering/ArtistsCatering';
import { ArtistsMobility } from '@/ui/pages/external/venue/dates/artists-mobility/ArtistsMobility';

import { externalLoader } from '../externalLoaders';

export const externalVenueDatesRoutes: RouteObject[] = [
  // Venue dates: full form
  {
    path: 'venue-dates-artists',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, { allowedScope: 'VENUE-DATES-ARTISTS' }),
    element: <Artists />,
  },
  // Venue dates: categories
  {
    path: 'venue-dates-artists-mobility',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, {
        allowedScope: 'VENUE-DATES-ARTISTS-MOBILITY',
      }),
    element: <ArtistsMobility />,
  },
  {
    path: 'venue-dates-artists-catering',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, {
        allowedScope: 'VENUE-DATES-ARTISTS-CATERING',
      }),
    element: <ArtistsCatering />,
  },
  {
    path: 'venue-dates-artists-accommodation',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, {
        allowedScope: 'VENUE-DATES-ARTISTS-ACCOMMODATION',
      }),
    element: <ArtistsAccommodation />,
  },
  {
    path: 'venue-dates-artists-cargo',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, {
        allowedScope: 'VENUE-DATES-ARTISTS-CARGO',
      }),
    element: <ArtistsCargo />,
  },
];
